import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const GenreService = {
    requestRootGenre: async () => {
        try {
            return await ApiService.getData("/v1/genre?rootOnly=true");
        } catch (error) {
            Logger.error(error);
            return null;
        }
    },

    requestGenre: async (id) => {
        const endpoint = id ? `/v1/genre/${id}` : `/v1/genre`;
        try {
            return await ApiService.getData(endpoint);
        } catch (error) {
            Logger.error(error);
            return null;
        }
    },

    createGenre: async (name, displayOrder, description, active, parentId) => {
        let params = {
            name,
            displayOrder,
            description,
            active,
        };

        if (parentId) {
            params["parentId"] = parentId;
        }
        // Logger.log(params);

        const result = await ApiService.postData(`/v1/genre`, params);
        // Logger.log(result);
        return result;
    },

    updateGenre: async (id, name, displayOrder, guardian_id, description, active) => {
        let params = {
            id,
            name,
            displayOrder,
            guardian_id,
            description,
            active,
        };
        // Logger.log(params);

        const result = await ApiService.putData(`/v1/genre`, params);
        // Logger.log(result);
        return result;
    },

    deleteGenre: async (id) => {
        const result = await ApiService.deleteData(`/v1/genre/${id}`);
        if (result && result.code === "FAILURE") {
            throw new Error(result.message || "Failed to delete genre");
        }
        return result;
    },
};

export default GenreService;
